export function modal(){
  let btnModal = document.querySelectorAll('[data-modal-button]');

  btnModal.forEach(function (item) {
    item.addEventListener('click', function () {
      console.log(item);
      console.log(btnModal);
      const modalBtn = this.dataset.modalButton;
      const modal = document.querySelector('#' + modalBtn);
      if (modal.classList.contains('hidden')) {
        modal.classList.remove('hidden');
      }
    })
  })
  let getFade = document.querySelectorAll('.modal__wrapper');
  getFade.forEach(function (item) {
    item.addEventListener('click', function (e) {
      if (this === e.target) {
        this.classList.add('hidden');
      }

    })
  })
  // fade click
  let modalCloseBtn = document.querySelectorAll('.modal__close--btn');
  modalCloseBtn.forEach(function (item) {
    item.addEventListener('click', function () {
      const modalParent = this.closest('[data-modal]');
      modalParent.classList.add('hidden');

    })
  })
}
